import { getFixedValue, convert } from "./currencyConvertion";

export const getServiceFeeValue = ({ serviceFees, totalWithoutServiceFee, base, rates, currency }) => {
    try {
        let guestServiceFee = 0, hostServiceFee = 0, guestServiceFeeType = '', hostServiceFeeType = '', guestServiceFeeValue = 0, hostServiceFeeValue;

        if (serviceFees?.guest) {
            guestServiceFeeType = serviceFees?.guest?.type;
            guestServiceFeeValue = serviceFees?.guest?.value;
            guestServiceFee = serviceFees?.guest?.type === 'percentage'
                ? totalWithoutServiceFee * (Number(serviceFees.guest.value) / 100)
                : getFixedValue(convert(base, rates, serviceFees.guest.value, serviceFees.guest.currency, currency));
        }

        if (serviceFees?.host) {
            hostServiceFeeType = serviceFees?.host?.type;
            hostServiceFeeValue = serviceFees?.host?.value;
            hostServiceFee = serviceFees.host.type === 'percentage'
                ? totalWithoutServiceFee * (Number(serviceFees.host.value) / 100)
                : getFixedValue(convert(base, rates, serviceFees.host.value, serviceFees.host.currency, currency));
        }

        return { guestServiceFee, hostServiceFee, hostServiceFeeType, guestServiceFeeType, guestServiceFeeValue, hostServiceFeeValue };
    } catch (error) {
        return { guestServiceFee: 0, hostServiceFee: 0, hostServiceFeeType: '', guestServiceFeeType: '', guestServiceFeeValue: 0, hostServiceFeeValue: 0 };
    }
};